// Test IDs for the join screen and the live video call room.

export const JOIN = {
  container: 'join-room-container',
  nameInput: 'join-name-input',
  roomInput: 'join-room-input',
  generateRoomBtn: 'join-generate-room-btn',
  joinBtn: 'join-room-btn',
  errorMessage: 'join-error-message',
};

export const CALL = {
  container: 'call-room-container',
  videoGrid: 'video-grid',
  localTile: 'local-video-tile',
  remoteTile: (userId) => `remote-video-tile-${userId}`,
  controlsBar: 'call-controls-bar',
  micBtn: 'toggle-mic-btn',
  cameraBtn: 'toggle-camera-btn',
  screenShareBtn: 'toggle-screenshare-btn',
  leaveBtn: 'leave-call-btn',
  copyLinkBtn: 'copy-room-link-btn',
  roomIdLabel: 'room-id-label',
  participantCount: 'participant-count',
  statusBadge: 'connection-status-badge',
  networkIndicator: (userId) => `network-indicator-${userId}`,
  toggleSidebarBtn: 'toggle-sidebar-btn',
  sidebar: 'participant-sidebar',
  sidebarItem: (userId) => `sidebar-participant-${userId}`,
  sidebarCloseBtn: 'sidebar-close-btn',
  blurBtn: 'toggle-blur-btn',
  captionsBtn: 'toggle-captions-btn',
  captionBar: 'live-caption-bar',
  captionPanelBtn: 'toggle-caption-panel-btn',
  captionPanel: 'caption-history-panel',
  captionPanelCloseBtn: 'caption-panel-close-btn',
  captionHistoryItem: (idx) => `caption-history-item-${idx}`,
  captionsFeatureBtn: 'toggle-captions-feature-btn',
  endMeetingBtn: 'end-meeting-btn',
  endMeetingDialog: 'end-meeting-dialog',
  endMeetingConfirmBtn: 'end-meeting-confirm-btn',
  endMeetingLeaveOnlyBtn: 'end-meeting-leave-only-btn',
  endMeetingCancelBtn: 'end-meeting-cancel-btn',
};
